<template>
    <app-layout ref="lo" title="Dashboard">
        <template #header>
            <BreadCrumb :breadcrumb="$page.props.bc" />
        </template>

        <div class="py-4">
            <div class="max-w-7xl mx-auto sm:px-6 lg:px-8">
                <div class="bg-white overflow-hidden shadow-xl sm:rounded-lg">
                    <section class="text-gray-600 body-font">
                        <div class="container px-5 py-12 mx-auto">
                            <div class="w-full mb-20">
                                <EzDataTable
                                    ref="ezdt"
                                    :config="ezdtConfig"
                                    @getSelectedData="getSelectedEdukLog"
                                />
                            </div>
                        </div>
                    </section>
                </div>
            </div>
        </div>
    </app-layout>
</template>

<script>
import { defineComponent } from "vue";
import AppLayout from "@/Layouts/AppLayout";
import BreadCrumb from "@/Components/BreadCrumb";
import { FilterMatchMode, FilterOperator } from "primevue/api";
import Toolbar from "primevue/toolbar";
import Select from "@/Components/Select";
import ButtonAdd from "@/Components/ButtonAdd";
import ButtonSync from "@/Components/ButtonSync";
import ButtonDelete from "@/Components/ButtonDelete";
import ButtonEdit from "@/Components/ButtonEdit";
import RekeningForm from "@/Pages/Setting/Partials/RekeningForm";
import InertiaButtonSave from "@/Components/InertiaButtonSave.vue";
import JetLabel from "@/Jetstream/Label";
import Checkbox from "primevue/checkbox";
import EzDataTable from "@/Components/EzDataTable";
import Alert from "@/Components/Alert";
import { Pesan } from "@/constants";

export default defineComponent({
    components: {
        Toolbar,
        AppLayout,
        BreadCrumb,
        ButtonAdd,
        ButtonSync,
        ButtonDelete,
        ButtonEdit,
        RekeningForm,
        InertiaButtonSave,
        JetLabel,
        Checkbox,
        EzDataTable,
        Select,
        Alert,
    },
    data() {
        return {
            tahun_sync: this.$page.props.setting.tahun_aktif,
            displayModal: false,
            selected_eduk_log_id: null,
            ezdtConfig: {
                dtHeader: "Eduk Log",
                sortBy: "tgl_ubah",
                sortOrder: "DESC",
                globalFilter: [
                    "nama_pegawai",
                    "nip",
                    "nama_tabel",
                    "nama_field",
                    "value_lama",
                    "value_baru",
                ],
                defineCols: [
                    {
                        field: "nama_pegawai",
                        header: "Nama Pegawai",
                        style: "min-width: 25rem",
                        isFrozen: true,
                        col_type: "text",
                    },
                    {
                        field: "nip",
                        header: "NIP",
                        style: "min-width: 15rem",
                        isFrozen: true,
                        col_type: "text",
                    },
                    {
                        field: "nama_tabel",
                        header: "Tabel",
                        style: "min-width: 15rem",
                        col_type: "text",
                    },
                    {
                        field: "nama_field",
                        header: "Field",
                        style: "min-width: 15rem",
                        col_type: "text",
                    },
                    {
                        field: "value_lama",
                        header: "Nilai Lama",
                        style: "min-width: 15rem",
                        col_type: "text",
                    },
                    {
                        field: "value_baru",
                        header: "Nilai Baru",
                        style: "min-width: 15rem",
                        col_type: "text",
                    },
                    {
                        field: "tgl_ubah",
                        header: "Tgl Ubah",
                        style: "min-width: 10rem",
                        col_type: "date",
                    },
                ],
                dtSourceApiRoute: {
                    list: "page.eduklogdata",
                    drop: null,
                },
            },
            selected_eduk_log: [],
            form: this.$inertia.form({
                _method: "PUT",
                id: null,
            }),
        };
    },
    methods: {
        loadEzData: function () {
            this.$refs.ezdt.loadData();
        },
        getSelectedEdukLog: function (data) {
            this.selected_eduk_log = data;
            this.selected_eduk_log_id = 0;
            if (data.length == 1) {
                this.selected_eduk_log_id = data[0]["id"];
            }
        },
        // sync: function (event) {
        //     let self = this;
        //     self.$confirm.require({
        //         target: event.currentTarget,
        //         message: "Yakin akan melakukan sync ?",
        //         icon: "pi pi-info-circle",
        //         acceptClass: "p-button-danger",
        //         accept: () => {
        //             axios
        //                 .post(route("page.eduklogdata"), {
        //                     tahun_sync: self.tahun_sync,
        //                 })
        //                 .then((res) => {
        //                     if (res.data.stts == Pesan.OK.STTS) {
        //                         self.$refs.ezdt.resetSelection();
        //                         self.$refs.ezdt.loadData();
        //                         self.$refs.lo.showPesan(
        //                             "Data berhasil di sync (...)."
        //                         );
        //                         self.$page.props.last_sync_at =
        //                             res.data.data.last_sync_at;
        //                         self.$page.props.sync_by =
        //                             res.data.data.sync_by;
        //                     }
        //                 })
        //                 .catch(function (error) {
        //                     //
        //                 })
        //                 .then(function () {
        //                     //
        //                 });
        //         },
        //         reject: () => {
        //             //callback to execute when user rejects the action
        //         },
        //     });
        // },
    },
});
</script>
